export default {
      id: "flag-usage",
      viewBox: "0 0 18 21",
      url: __webpack_public_path__ + "sprite.svg#flag",
      toString: function () {
        return this.url;
      }
    }